import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Message } from '../models/message.model';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  private messageSubject$ = new Subject<Message | undefined>();
  hasMessage$ = this.messageSubject$.asObservable();

  show(message?: Message): void {
    if (!message) {
      message = {
        text: 'Sorry, an error has occurred',
        placement: 'BottomCenter',
        duration: 5000,
        design: 'Error',
      };
    }
    this.messageSubject$.next(message);
  }
}
